//USER IDS WHICH WE WANT TO LOGOUT FORCEFULLY
const forceLogoutIds = [26768];

export const isForceLogout = (userId) => {
  const userIdMatch = forceLogoutIds.findIndex((val) => val === userId);
  return userIdMatch === -1 ? false : true;
};
